/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAddTicketCommentInput = {
    clientMutationId?: string | null;
    ticketSlug: string;
    comment: string;
};
export type ExternalTicketShowAddCommentMutationVariables = {
    input: infoAddTicketCommentInput;
};
export type ExternalTicketShowAddCommentMutationResponse = {
    readonly infoAddTicketComment: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ExternalTicketShowAddCommentMutation = {
    readonly response: ExternalTicketShowAddCommentMutationResponse;
    readonly variables: ExternalTicketShowAddCommentMutationVariables;
};



/*
mutation ExternalTicketShowAddCommentMutation(
  $input: infoAddTicketCommentInput!
) {
  infoAddTicketComment(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAddTicketCommentPayload",
    "kind": "LinkedField",
    "name": "infoAddTicketComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalTicketShowAddCommentMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalTicketShowAddCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3155b8dde1c792c0a65628972820d6a7",
    "id": null,
    "metadata": {},
    "name": "ExternalTicketShowAddCommentMutation",
    "operationKind": "mutation",
    "text": "mutation ExternalTicketShowAddCommentMutation(\n  $input: infoAddTicketCommentInput!\n) {\n  infoAddTicketComment(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '73489512c1b5f69f551358ac61d97b71';
export default node;
